import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Input } from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import * as RelatoriosActions from '../../tabs/Relatorios/store/relatorios.action';
import Row from 'reactstrap/lib/Row';
import CommonFunctions from '@common/util/functions.common';
import IntlMessage from "../../../../helpers/intlMessage";
import SelectComponent from '@componentes/select/select.component';
import { changePeriod, getDate, obterListagemDePeriodos } from '../../../../helpers';
import { useIntl } from 'react-intl';

export default function ComponentesArquivamento({ component, onPressEnter }) {
  const dispatch = useDispatch();
  const carregando = useSelector(state => state.commonReducer.showCarregando);
  const relatorioDataInicio = useSelector(state => state.arquivamentoRelatorios.dataInicio);
  const relatorioDataFim = useSelector(state => state.arquivamentoRelatorios.dataFim);
  const relatorioFiltroValue = useSelector(state => state.arquivamentoRelatorios.filtroValue);
  const intl = useIntl();
  const periodo = useSelector(state => state.arquivamentoRelatorios.tipoPeriodo);
  const periodos = obterListagemDePeriodos(intl);

  function resetarPeriodo() {
    dispatch(RelatoriosActions.tipoPeriodo(''));
    montAction('dtini', null);
    montAction('dtfim', null);
	}

	function periodoAlterado(e) {
		if (!e || !e.value) {
		  return resetarPeriodo();
		}

		let payload = getDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

    dispatch(RelatoriosActions.tipoPeriodo(e));
    montAction('dtini', payload.dtinicial);
    montAction('dtfim', payload.dtfinal);
	}

  function mudarIntervaloPeriodo(val) {
		let payload = changePeriod(val);

    montAction('dtini', payload.start);
    montAction('dtfim', payload.end);
	}

  function changeInput(tipo) {

    if (tipo === 'dtini') {
      return relatorioDataInicio;
    } else if (tipo === 'dtfim') {
      return relatorioDataFim;
    } else {
      return relatorioFiltroValue;
    }
  }

  function resetInput() {
    dispatch(RelatoriosActions.filtroValue(''));

    let tipoPeriodo = { value: 'hoje', label: `${intl.formatMessage({ id: "period.today" })}` };
    dispatch(RelatoriosActions.tipoPeriodo(tipoPeriodo));
  }

  useEffect(() => {
    obterPeriodos();
    resetInput();
  }, []);

  function montAction(tipo, val) {
    if (tipo === 'dtini') {
      return dispatch(RelatoriosActions.dataInicio(val));
    } else if (tipo === 'dtfim') {
      return dispatch(RelatoriosActions.dataFim(val));
    } else {
      return dispatch(RelatoriosActions.filtroValue(val));
    }
  }

  function changeInicio(e) {
    let date = e.target.value;
    montAction('dtini', date);
  }
  function changeFim(e) {
    let date = e.target.value;
    montAction('dtfim', date);
  }

  function obterPeriodos() {
    const periodos = CommonFunctions.getPeriodosSubDays(0);
    montAction('dtini', periodos.periodoInicial);
    montAction('dtfim', periodos.periodoFinal);
  }

  function DTPeriodoInicioFim(props) {
    return (
      <React.Fragment>
        <Row>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'auto', width: 'auto' }}>
            <div className="label-data"><IntlMessage id="period.name"/></div>
            <div className="form-group has-float-label" style={{width: '200px', display: 'block'}}>
              <SelectComponent
                isClearable
                className="filtro-data"
                noOptionsMessage={() => {return <IntlMessage id="dashboards.reports.noItemsFound"/>}}
                name="form-field-period"
                placeholder={<IntlMessage id="dashboards.general.selectPeriod"/>}
                value={periodo}
                onChange={(e) => {
                  periodoAlterado(e);
                  e && e.value ? mudarIntervaloPeriodo(e.value) : mudarIntervaloPeriodo('todos');
                }}
                options={periodos}
              />
            </div>

            {periodo && periodo.value === 'outro' && (
              <React.Fragment>
                <DebounceInput
                  debounceTimeout={900}
                  name="periodoDe"
                  type="date"
                  style={{width: '130px', display: 'block'}}
                  className="filtro-data"
                  value={changeInput('dtini')}
                  onChange={(e) => {changeInicio(e)}}
                  onKeyPress={(e) => onKeyPressInput(e)}
                />
                <DebounceInput
                  debounceTimeout={900}
                  name="periodoAte"
                  type="date"
                  style={{width: '130px', display: 'block'}}
                  className="filtro-data"
                  value={changeInput('dtfim')}
                  onChange={(e) => {changeFim(e)}}
                  onKeyPress={(e) => onKeyPressInput(e)}
                />
              </React.Fragment>
            )}
          </div>
        </Row>
      </React.Fragment>
    );
  }

  function InputString(props) {

    let type = 'text';

    switch (props.valida) {
      case 'peso':
      case 'items':
      case 'diasavencer':
        type = 'number';
        break;

      default:
        break;
    }
    function validaInput(el) {
      if (props.valida === 'peso') {
        if (Number(el) <= 0) {
          montAction('', 0);
        } else {
          montAction('', Number(el));
        }
      } else if (props.valida === 'items') {
        if (Number(el) <= 0) {
          montAction('', '');
        } else {
          montAction('', Number(el));
        }
      } else if (props.valida === 'diasavencer') {
        const value = changeInput();
        if (Number(el) > 0 && Number(el) < 90) {
          montAction('', (el.toString()));
        } else if (value.length === 1 && el === '') {
          montAction('', '');
        } else {
          montAction('', value);
        }
      } else {
        montAction('', el);
      }
    }
    return (
      <div className={`nome-${props.component}`}>
        <Input
          ref={() => {
            document.getElementById(props.component).focus();
          }}
          id={props.component}
          name={props.component}
          value={changeInput()}
          type={type}
          onChange={e => {
            validaInput(e.target.value);
          }}
          onKeyPress={onKeyPressInput}
        />
      </div>
    );
  }

  function onKeyPressInput(event) {
    if (event.key === 'Enter' && onPressEnter) {
      onPressEnter();
    }
  }

  function CustomComponent({ component }) {
    switch (component) {
      case 'dtpedido':
      case 'dtvencimento':
      case 'dtrecebimento':
      case 'dtsolicitacao':
      case 'dtarquivamento':
      case 'dtdevolucao':
        return <DTPeriodoInicioFim />;
      case 'items':
      case 'nrPedido':
      case 'idfrasco':
      case 'descricao':
      case 'nrExame':
      case 'paciente':
      case 'usuario':
        return <InputString component={component} />;
      default:
        return <div></div>;
    }
  }

  return <CustomComponent component={component} />;
}



// WEBPACK FOOTER //
// ./src/pages/arquivamento/common/components/index.js